import { LancementView } from "@features/production/components/LancementView";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Eye } from "lucide-react";

export const Route = createFileRoute("/_app/production/lancements/$id/")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.LANCEMENTS.VIEW),
  staticData: {
    title: "Détail lancement",
    icon: Eye,
    permission: PERMISSIONS.PRODUCTION.LANCEMENTS.VIEW,
    section: "App",
    showInBreadcrumb: true,
  },
  component: LancementView,
});
